import { Button } from '@/global/components/Button'
import { useLocationTestId } from '@/hooks/useTestId'
import localeText from '@/locales/datagrid'
import { PlusIcon } from 'lucide-react'
import React from 'react'
import { match } from 'ts-pattern'
import { IDataTableProps } from '../DataTable'

interface IProps {
    onAdd?: IDataTableProps['onAdd']
    children?: React.ReactNode
}

export default function GridToolbarRightSide({ children, onAdd }: IProps) {
    const adicionarTestId = useLocationTestId('adicionar')

    return (
        <div className="inline-flex items-center gap-2">
            {children}
            {match(onAdd)
                .when(
                    () => React.isValidElement(onAdd),
                    () => onAdd as React.ReactNode,
                )
                .when(
                    () => typeof onAdd === 'function',
                    () => (
                        <Button
                            onClick={onAdd as () => void}
                            data-testid={adicionarTestId}
                            startIcon={<PlusIcon />}
                        >
                            <span className="hidden sm:block">
                                {localeText.filterPanelAddFilter}
                            </span>
                        </Button>
                    ),
                )
                .otherwise(() => null)}
        </div>
    )
}
